import React from 'react'
import { TExtraField, TExtraFieldValue } from '../../../../models/ExtraField'
import { Form, Input } from 'antd'

interface Props {
  idx: number
  fieldConfig: TExtraField
  fieldValue: TExtraFieldValue
}

export const ExtraFieldFormValuesText = ({ idx, fieldConfig, fieldValue }: Props) => (
  <Form.Item
    key={fieldConfig.id}
    label={fieldConfig.name}
    name={['fields', idx, 'value']}
    rules={fieldConfig.required ? [{ required: true }] : []}
    extra={fieldConfig.extraId}
  >
    <Input />
  </Form.Item>
)
